import * as _ from 'lodash';
import { useMemo } from 'react';
import type { Column } from 'react-table';

import styles from './SimpleReactTable.module.less';

/**
 * useStyledColumns is a hook that applies styles to the columns of a table.
 * Mostly used to apply a border to resizable columns.
 *
 * @param {Column[]} columns - The columns of the table.
 * @returns {Column[]} The columns of the table with the styles applied.
 */
const useStyledColumns = (columns: Column[]): Column[] => {
  return useMemo<Column[]>(() => columns.map((column) => {
    // resizable is true by default
    if (column.resizable || _.isNil(column.resizable)) {
      return {
        ...column,
        className: styles.resizableCell,
      };
    }
    return column;
  }), [columns]);
};

export default useStyledColumns;
